import { gql } from '@apollo/client';

export const bulkUpdateRequests = gql`
  mutation bulkUpdateRequest(
    $requestId: Float
    $requestNumber: String
    $status: String
    $requestorName: String
    $requestorPhoneNumber: String
    $requestorEmail: String
    $equipmentType: String
    $equipmentCategory: String
    $purchaseOrderNumber: String
    $chargeAccount: String
    $deliveryLocation: String
    $deliveryDate: DateTime
    $needsBarcode: Boolean
    $quantity: Float
    $notes: String
    $isCovid: Boolean
    $attachment: String
  ) {
    bulkEditRequests(
      input: {
        requestId: $requestId
        requestNumber: $requestNumber
        status: $status
        requestorName: $requestorName
        requestorPhoneNumber: $requestorPhoneNumber
        requestorEmail: $requestorEmail
        equipmentType: $equipmentType
        equipmentCategory: $equipmentCategory
        purchaseOrderNumber: $purchaseOrderNumber
        chargeAccount: $chargeAccount
        deliveryLocation: $deliveryLocation
        deliveryDate: $deliveryDate
        needsBarcode: $needsBarcode
        quantity: $quantity
        notes: $notes
        isCovid: $isCovid
        attachment: $attachment
      }
    ) {
      requestId
    }
  }
`;

export const pageRequestedItems = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!]) {
    pageRequestedItems(grid: { amount: $amount, field: $field, page: $page, filters: $filters }) {
      count
      data {
        requestedItemId
        barcode
        assetNumber
        department
        deliveryDate
        dateEnteredInEnterpriseOne
        description1
        description2
        description3
        requestId
        requestItemFYNumber
        serialNumber
        purchaseOrderNumber
        accountNumber
        parentNumber
        amountPaid
        originalQuantity
        currentQuantity
        remarks1
        remarks2
        remarks3
        physicalOwner
        originalPurchaser
        newOrUsed
        companyNumber
        responsibleBusinessUnit
        location
        majorAccountingClass
        majorEquipmentClass
        manufacturer
        function
        categoryCode6
        status
        needsImaging
        isCovid
        attachment
      }
    }
  }
`;

export const requestedItemsByFY = gql`
  query requestedItemsByRequestNumber($fyNumber: String!) {
    requestedItemsByRequestNumber(fyNumber: $fyNumber) {
      id
      barcode
      assetNumber
      department
      deliveryDate
      dateEnteredInEnterpriseOne
      description1
      description2
      description3
      requestItemFYNumber
      serialNumber
      purchaseOrderNumber
      accountNumber
      parentNumber
      amountPaid
      originalQuantity
      currentQuantity
      remarks1
      remarks2
      remarks3
      physicalOwner
      originalPurchaser
      newOrUsed
      companyNumber
      responsibleBusinessUnit
      location
      majorAccountingClass
      majorEquipmentClass
      manufacturer
      function
      categoryCode6
      status
      needsImaging
      isCovid
      attachment
    }
  }
`;

export const nextAndPreviousRequest = gql`
  query nextAndPreviousRequest($requestId: Int!) {
    nextAndPreviousRequest(requestId: $requestId)
  }
`;

export const updateRequestMutation = gql`
  mutation updateRequest(
    $requestId: Float
    $requestNumber: String
    $status: String
    $requestorName: String
    $requestorPhoneNumber: String
    $requestorEmail: String
    $equipmentType: String
    $equipmentCategory: String
    $purchaseOrderNumber: String
    $chargeAccount: String
    $deliveryLocation: String
    $deliveryDate: DateTime
    $needsBarcode: Boolean
    $propertyCoordinatorId: Int
    $quantity: Float
    $notes: String
    $isCovid: Boolean
    $attachment: String
    $orderDate: DateTime
    $orderNumber: String
    $orderAmount: Float
    $vendor: String
    $oitNotes: String
    $barcodeType: String
    $requestDate: DateTime
    $requestorDivision: String
    $oitStock: Boolean
    $fulfillingDivision: String
    $fulfillingDepartment: Float
  ) {
    updateRequest(
      input: {
        requestId: $requestId
        requestNumber: $requestNumber
        status: $status
        requestorName: $requestorName
        requestorPhoneNumber: $requestorPhoneNumber
        requestorEmail: $requestorEmail
        equipmentType: $equipmentType
        equipmentCategory: $equipmentCategory
        purchaseOrderNumber: $purchaseOrderNumber
        chargeAccount: $chargeAccount
        deliveryLocation: $deliveryLocation
        deliveryDate: $deliveryDate
        needsBarcode: $needsBarcode
        quantity: $quantity
        propertyCoordinatorId: $propertyCoordinatorId
        notes: $notes
        isCovid: $isCovid
        attachment: $attachment
        orderDate: $orderDate
        orderNumber: $orderNumber
        orderAmount: $orderAmount
        vendor: $vendor
        oitNotes: $oitNotes
        barcodeType: $barcodeType
        requestDate: $requestDate
        requestorDivision: $requestorDivision
        oitStock: $oitStock
        fulfillingDivision: $fulfillingDivision
        fulfillingDepartment: $fulfillingDepartment
      }
    ) {
      requestId
    }
  }
`;

export const bulkUpdateRequestedItemMutation = gql`
  mutation bulkEditRequestedItems(
    $id: Int
    $barcode: String
    $assetNumber: String
    $department: String
    $deliveryDate: DateTime
    $dateEnteredInEnterpriseOne: DateTime
    $description1: String
    $description2: String
    $description3: String
    $request: RequestInput
    $requestItemFYNumber: String
    $serialNumber: String
    $purchaseOrderNumber: String
    $accountNumber: String
    $parentNumber: String
    $amountPaid: Float
    $originalQuantity: Float
    $currentQuantity: Float
    $remarks1: String
    $remarks2: String
    $remarks3: String
    $physicalOwner: String
    $originalPurchaser: String
    $newOrUsed: String
    $companyNumber: String
    $responsibleBusinessUnit: String
    $location: String
    $majorAccountingClass: String
    $majorEquipmentClass: String
    $manufacturer: String
    $function: String
    $categoryCode6: String
    $status: String
    $needsImaging: Boolean
    $isCovid: Boolean
    $attachment: String
  ) {
    bulkEditRequestedItems(
      input: {
        id: $id
        barcode: $barcode
        assetNumber: $assetNumber
        deliveryDate: $deliveryDate
        department: $department
        dateEnteredInEnterpriseOne: $dateEnteredInEnterpriseOne
        description1: $description1
        description2: $description2
        description3: $description3
        request: $request
        requestItemFYNumber: $requestItemFYNumber
        serialNumber: $serialNumber
        purchaseOrderNumber: $purchaseOrderNumber
        accountNumber: $accountNumber
        parentNumber: $parentNumber
        amountPaid: $amountPaid
        originalQuantity: $originalQuantity
        currentQuantity: $currentQuantity
        remarks1: $remarks1
        remarks2: $remarks2
        remarks3: $remarks3
        physicalOwner: $physicalOwner
        originalPurchaser: $originalPurchaser
        newOrUsed: $newOrUsed
        companyNumber: $companyNumber
        responsibleBusinessUnit: $responsibleBusinessUnit
        location: $location
        majorAccountingClass: $majorAccountingClass
        majorEquipmentClass: $majorEquipmentClass
        manufacturer: $manufacturer
        function: $function
        categoryCode6: $categoryCode6
        status: $status
        needsImaging: $needsImaging
        isCovid: $isCovid
        attachment: $attachment
      }
    ) {
      id
    }
  }
`;

export const updateRequestedItemMutation = gql`
  mutation updateItem(
    $id: Int
    $barcode: String
    $assetNumber: String
    $department: String
    $deliveryDate: DateTime
    $dateEnteredInEnterpriseOne: DateTime
    $description1: String
    $description2: String
    $description3: String
    $request: RequestInput
    $requestItemFYNumber: String
    $serialNumber: String
    $purchaseOrderNumber: String
    $accountNumber: String
    $parentNumber: String
    $amountPaid: Float
    $originalQuantity: Float
    $currentQuantity: Float
    $remarks1: String
    $remarks2: String
    $remarks3: String
    $physicalOwner: String
    $originalPurchaser: String
    $newOrUsed: String
    $companyNumber: String
    $responsibleBusinessUnit: String
    $location: String
    $majorAccountingClass: String
    $majorEquipmentClass: String
    $manufacturer: String
    $function: String
    $categoryCode6: String
    $status: String
    $needsImaging: Boolean
    $isCovid: Boolean
    $attachment: String
  ) {
    updateItem(
      requestedItem: {
        id: $id
        barcode: $barcode
        assetNumber: $assetNumber
        deliveryDate: $deliveryDate
        department: $department
        dateEnteredInEnterpriseOne: $dateEnteredInEnterpriseOne
        description1: $description1
        description2: $description2
        description3: $description3
        request: $request
        requestItemFYNumber: $requestItemFYNumber
        serialNumber: $serialNumber
        purchaseOrderNumber: $purchaseOrderNumber
        accountNumber: $accountNumber
        parentNumber: $parentNumber
        amountPaid: $amountPaid
        originalQuantity: $originalQuantity
        currentQuantity: $currentQuantity
        remarks1: $remarks1
        remarks2: $remarks2
        remarks3: $remarks3
        physicalOwner: $physicalOwner
        originalPurchaser: $originalPurchaser
        newOrUsed: $newOrUsed
        companyNumber: $companyNumber
        responsibleBusinessUnit: $responsibleBusinessUnit
        location: $location
        majorAccountingClass: $majorAccountingClass
        majorEquipmentClass: $majorEquipmentClass
        manufacturer: $manufacturer
        function: $function
        categoryCode6: $categoryCode6
        status: $status
        needsImaging: $needsImaging
        isCovid: $isCovid
        attachment: $attachment
      }
    ) {
      id
    }
  }
`;

export const updateEOneItemMutation = gql`
  mutation updateEOneItem(
    $id: Int
    $assetNumber: String
    $description1: String
    $description2: String
    $description3: String
    $updateStatus: String
    $accountNumber: String
    $additionalRemarks: String
    $additionalRemarks2: String
    $additionalRemarks3: String
    $assetItemCurrentQuantity: Float
    $assetItemOriginalQuantity: Float
    $barcode: String
    $businessUnit: String
    $categoryCode6: String
    $companyNumber: String
    $dateAcquired: DateTime
    $department: String
    $equipmentStatus: String
    $itemFunction: String
    $locationDescription: String
    $location: String
    $majorAccountingClass: String
    $majorEquipmentClass: String
    $manufacturer: String
    $newOrUsed: String
    $originalPurchaser: String
    $parentNumber: String
    $physicalOwner: String
    $poNumber: String
    $serialNumber: String
    $updateDate: DateTime
    $updateType: String
  ) {
    updateEOneItem(
      input: {
        id: $id
        assetNumber: $assetNumber
        description1: $description1
        description2: $description2
        description3: $description3
        updateStatus: $updateStatus
        accountNumber: $accountNumber
        additionalRemarks: $additionalRemarks
        additionalRemarks2: $additionalRemarks2
        additionalRemarks3: $additionalRemarks3
        assetItemCurrentQuantity: $assetItemCurrentQuantity
        assetItemOriginalQuantity: $assetItemOriginalQuantity
        barCode: $barcode
        businessUnit: $businessUnit
        categoryCode6: $categoryCode6
        companyNumber: $companyNumber
        dateAcquired: $dateAcquired
        department: $department
        equipmentStatus: $equipmentStatus
        itemFunction: $itemFunction
        locationDescription: $locationDescription
        location: $location
        majorAccountingClass: $majorAccountingClass
        majorEquipmentClass: $majorEquipmentClass
        manufacturer: $manufacturer
        newOrUsed: $newOrUsed
        originalPurchaser: $originalPurchaser
        parentNumber: $parentNumber
        physicalOwner: $physicalOwner
        poNumber: $poNumber
        serialNumber: $serialNumber
        updateDate: $updateDate
        updateType: $updateType
      }
    ) {
      id
    }
  }
`;

export const createRequestedItem = gql`
  mutation createReqItemFromRequest(
    $requestId: Float
    $requestNumber: String
    $status: String
    $requestorName: String
    $requestorPhoneNumber: String
    $requestorEmail: String
    $equipmentType: String
    $equipmentCategory: String
    $purchaseOrderNumber: String
    $chargeAccount: String
    $deliveryLocation: String
    $deliveryDate: DateTime
    $needsBarcode: Boolean
    $quantity: Float
    $notes: String
  ) {
    createReqItemFromRequest(
      request: {
        requestId: $requestId
        requestNumber: $requestNumber
        status: $status
        requestorName: $requestorName
        requestorPhoneNumber: $requestorPhoneNumber
        requestorEmail: $requestorEmail
        equipmentType: $equipmentType
        equipmentCategory: $equipmentCategory
        purchaseOrderNumber: $purchaseOrderNumber
        chargeAccount: $chargeAccount
        deliveryLocation: $deliveryLocation
        deliveryDate: $deliveryDate
        needsBarcode: $needsBarcode
        quantity: $quantity
        notes: $notes
      }
    ) {
      id
    }
  }
`;

export const checkForReqItemByFY = gql`
  query findReqItemByFY($reqItemFYNumber: String) {
    findReqItemByFY(reqItemFYNumber: $reqItemFYNumber) {
      requestItemFYNumber
    }
  }
`;

export const checkForExistingTagNumber = gql`
  query getOracleItemByTagNumber($barcode: String!){
    getOracleItemByTagNumber(barcode: $barcode){
      id
    }
  }
`

export const queryAppUsers = gql`
  query {
    readAllApplicationUsers {
      id
      adId
      name
      emailAddress
    }
  }
`;

export const editRequestLineItemStatus = gql`
  mutation editRequestLineItems($json: String!, $newStatus: String!) {
    editRequestLineItems(json: $json, newStatus: $newStatus)
  }
`;

export const checkForEOneByBarcode = gql`
  query findEOneByBarcode($barcode: String, $moveToEOne: Boolean) {
    findEOneByBarcode(barcode: $barcode, moveToEOne: $moveToEOne) {
      barCode
    }
  }
`;

export const markRequestedItemComplete = gql`
  mutation markRequestedItemComplete($barcode: String!) {
    markRequestedItemComplete(barcode: $barcode)
  }
`;

export const findRequestNumberFromBarcode = gql`
  query requestNumberFromBarcode($barcode: String!) {
    requestNumberFromBarcode(barcode: $barcode) {
      requestItemFYNumber
    }
  }
`;

export const createEOneItem = gql`
  mutation createEOneFromReqItem(
    $id: Int
    $barcode: String
    $assetNumber: String
    $department: String
    $deliveryDate: DateTime
    $dateEnteredInEnterpriseOne: DateTime
    $description1: String
    $description2: String
    $description3: String
    $serialNumber: String
    $purchaseOrderNumber: String
    $accountNumber: String
    $parentNumber: String
    $amountPaid: Float
    $originalQuantity: Float
    $currentQuantity: Float
    $remarks1: String
    $remarks2: String
    $remarks3: String
    $physicalOwner: String
    $originalPurchaser: String
    $newOrUsed: String
    $companyNumber: String
    $location: String
    $majorAccountingClass: String
    $majorEquipmentClass: String
    $manufacturer: String
    $function: String
    $categoryCode6: String
  ) {
    createEOneFromReqItem(
      requestedItem: {
        id: $id
        barcode: $barcode
        assetNumber: $assetNumber
        deliveryDate: $deliveryDate
        department: $department
        dateEnteredInEnterpriseOne: $dateEnteredInEnterpriseOne
        description1: $description1
        description2: $description2
        description3: $description3
        location: $location
        accountNumber: $accountNumber
        physicalOwner: $physicalOwner
        originalPurchaser: $originalPurchaser
        function: $function
        categoryCode6: $categoryCode6
        manufacturer: $manufacturer
        majorEquipmentClass: $majorEquipmentClass
        companyNumber: $companyNumber
        remarks1: $remarks1
        remarks2: $remarks2
        remarks3: $remarks3
        serialNumber: $serialNumber
        purchaseOrderNumber: $purchaseOrderNumber
        parentNumber: $parentNumber
        amountPaid: $amountPaid
        originalQuantity: $originalQuantity
        currentQuantity: $currentQuantity
        newOrUsed: $newOrUsed
        majorAccountingClass: $majorAccountingClass
      }
    ) {
      id
    }
  }
`;

export const createAuditMutation = gql`
  mutation createAudit(
    $barcode: String
    $comment: String
    $createdBy: String
    $createdOn: DateTime
    $lastUpdatedBy: String
    $updatedOn: DateTime
    $requestId: Float!
    $entryType: String
  ) {
    createAudit(
      comment: {
        barcode: $barcode
        comment: $comment
        createdBy: $createdBy
        createdOn: $createdOn
        lastUpdatedBy: $lastUpdatedBy
        updatedOn: $updatedOn
        requestId: $requestId
        entryType: $entryType
      }
    ) {
      id
    }
  }
`;
